import React, { useContext } from 'react';
import { UserContext } from '../../hooks/UserContext';
import { Navigate } from "react-router";

//  Components
import LoginForm from '../../components/Forms/LoginForm';

const Login = () => {
    const { user } = useContext(UserContext);
    return (user ? <Navigate to='/admin'/> : <LoginForm/>)
}

export default Login;